import {Component, OnInit, inject} from '@angular/core';
import {I18nService} from '../_services/gui/i18n.service';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
    imports: [TranslateModule]
})
export class PageNotFoundComponent implements OnInit {
  private i18nService = inject(I18nService);


  ngOnInit() {
    this.i18nService.setTitle('title.page-not-found');
  }

}
